import { useState, useEffect } from "react";

function SplashContent(){
  return(
    <div className="splash-wrap">
      <div className="splash-glow"/>
      <div className="splash-tile">
        <img src="/icon.svg" alt="" className="splash-logo-img"/>
      </div>
    </div>
  );
}

/* Cold-start splash — branded design, logo animates in, min 1s display */
function AnimatedSplash({appName,onDone}){
  const [phase,setPhase]=useState("show");
  useEffect(()=>{
    const t1=setTimeout(()=>setPhase("out"),1000);
    const t2=setTimeout(()=>{setPhase("done");onDone();},1500);
    return()=>{clearTimeout(t1);clearTimeout(t2);};
  },[]);// eslint-disable-line react-hooks/exhaustive-deps
  if(phase==="done") return null;
  return(
    <div className={`splash-screen ${phase==="out"?"out":""}`}>
      <SplashContent/>
      <div className="splash-loading"><span className="splash-loading-pulse">{typeof document!=="undefined"&&document.documentElement.lang==="ar"?"جارٍ التحميل":"LOADING"}</span></div>
    </div>
  );
}

/* Loading splash — same dark design, stays until data ready */
function LoadingSplash({appName,tagline}){
  return(
    <div className="splash-screen">
      <SplashContent/>
      <div className="splash-loading"><span className="splash-loading-pulse">{typeof document!=="undefined"&&document.documentElement.lang==="ar"?"جارٍ التحميل":"LOADING"}</span></div>
    </div>
  );
}

export { SplashContent, AnimatedSplash, LoadingSplash };
